import type { CompendiumEntry } from "./compendium";

const loaded = new Map<string, Promise<readonly CompendiumEntry[]>>();

async function fetchCompendium(bookId: string): Promise<readonly CompendiumEntry[]> {
  const response = await fetch(`/book-data/${bookId}/compendium.json`);
  if (!response.ok || !(response.headers.get("content-type") ?? "").includes("json")) {
    return [];
  }
  return (await response.json() as { entries: CompendiumEntry[] }).entries;
}

/** A book's compendium, fetched once. A book without one has an empty list. */
export function loadCompendium(bookId: string): Promise<readonly CompendiumEntry[]> {
  let entries = loaded.get(bookId);
  if (entries === undefined) {
    entries = fetchCompendium(bookId).catch(() => []);
    loaded.set(bookId, entries);
  }
  return entries;
}
